<template>
  <img class="brand-icon" :src="iconUrl" :alt="alt" @click="onClick" />
</template>

<script>
export default {
  props: {
    iconUrl: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: 'brand-icon'
    }
  },
  methods: {
    onClick() {
      this.$emit('click-image')
    }
  }
}
</script>
<style lang="scss" scoped>
.brand-icon {
  @extend %hover-common;
  width: 100%;
  height: 100%;
  max-width: 115px;
  min-width: 0;
  max-height: 115px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
}
</style>
